{
  "name": "@jvittechs/j",
  "version": "1.0.103",
  "description": "A unified CLI tool for JV-IT TECHS developers to manage Jai1 Framework. Supports both `j` and `jai1` commands. Please contact TeamAI for usage instructions.",
  "type": "module",
  "bin": {
    "j": "dist/cli.js",
    "jai1": "dist/cli.js"
  },
  "exports": {
    ".": "./dist/cli.js"
  },
  "files": [
    "dist",
    "redmine.config.example.yaml",
    "scripts/redmine-sync-issue.sh",
    "scripts/postinstall.js"
  ],
  "engines": {
    "node": ">=20"
  },
  "license": "MIT",
  "author": "JVIT <dev@jvit.com>",
  "repository": {
    "type": "git",
    "url": "git+https://github.com/jvittechs/jai.git",
    "directory": "packages/cli"
  },
  "homepage": "https://github.com/jvittechs/jai/tree/main/packages/cli#readme",
  "keywords": [
    "jai1",
    "framework",
    "redmine",
    "cli",
    "markdown",
    "issues",
    "context",
    "agentic",
    "coding"
  ],
  "scripts": {
    "postinstall": "node scripts/postinstall.js",
    "bundle:guide": "node scripts/bundle-guide-content.js",
    "build": "npm run bundle:guide && tsup src/cli.ts --dts --format esm --target node22 --out-dir dist --sourcemap && npm run copy-web-chat",
    "copy-web-chat": "mkdir -p dist/web-chat && cp -r src/web-chat/* dist/web-chat/",
    "dev": "tsx src/cli.ts --help",
    "lint": "eslint .",
    "test": "vitest run",
    "release": "node scripts/release.js",
    "smart-publish": "node scripts/smart-publish.js"
  },
  "dependencies": {
    "@inquirer/prompts": "^8.0.2",
    "adm-zip": "^0.5.16",
    "bcryptjs": "^2.4.3",
    "boxen": "^8.0.1",
    "chalk": "^5.6.2",
    "cli-progress": "^3.12.0",
    "cli-table3": "^0.6.5",
    "clipboardy": "^4.0.0",
    "commander": "^12.1.0",
    "cronstrue": "^2.50.0",
    "execa": "^9.6.1",
    "figlet": "^1.9.4",
    "gradient-string": "^3.0.0",
    "gray-matter": "^4.0.3",
    "ignore": "^7.0.5",
    "ink": "^5.0.1",
    "ink-spinner": "^5.0.0",
    "ink-text-input": "^6.0.0",
    "marked": "^12.0.0",
    "marked-terminal": "^7.0.0",
    "open": "^10.1.0",
    "ora": "^9.0.0",
    "p-limit": "^5.0.0",
    "p-queue": "^7.4.1",
    "p-retry": "^6.2.0",
    "react": "^18.3.1",
    "slugify": "^1.6.6",
    "sharp": "^0.33.5",
    "terminal-image": "^4.1.0",
    "undici": "^6.19.5",
    "yaml": "^2.5.0",
    "zod": "^3.23.8"
  },
  "devDependencies": {
    "@changesets/cli": "^2.27.7",
    "@types/figlet": "^1.7.0",
    "@types/gradient-string": "^1.1.6",
    "@types/node": "^24.10.1",
    "@types/react": "^18.3.12",
    "@typescript-eslint/eslint-plugin": "^8.6.0",
    "@typescript-eslint/parser": "^8.6.0",
    "@vitest/coverage-v8": "^2.1.4",
    "eslint": "^9.9.0",
    "prettier": "^3.3.3",
    "tsup": "^8.1.0",
    "tsx": "^4.19.2",
    "typescript": "^5.6.3",
    "vitest": "^2.1.4"
  }
}
